import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from '@/components/ui/button';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { path: '/meet-kalinda', label: 'Meet Kalinda' },
    { path: '/issues', label: 'Issues' },
    { path: '/volunteer', label: 'Get Involved' },
    { path: '/news', label: 'News' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className={`bg-white sticky top-0 z-50 transition-all duration-300 ${scrolled ? 'shadow-md' : 'shadow-sm'}`}>
      {/* Top accent bar */}
      <div className="h-1 bg-gradient-to-r from-red-600 via-white to-[#0a1628]"></div>
      
      <div className="container mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between py-4">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img 
              src="https://customer-assets.emergentagent.com/job_f99a18a4-e930-4176-ac10-f2e206aadd3b/artifacts/tclbelzy_content.png" 
              alt="Kalinda for NYS Assembly" 
              className="h-14 md:h-16 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`font-medium text-sm uppercase tracking-wide transition-colors duration-200 hover:text-red-600 relative ${
                  isActive(link.path) ? 'text-red-600' : 'text-[#0a1628]'
                }`}
              >
                {link.label}
                {isActive(link.path) && (
                  <span className="absolute -bottom-1 left-0 right-0 h-0.5 bg-red-600"></span>
                )}
              </Link>
            ))}
            <a href="https://buy.stripe.com/4gMeVec2v4oP6XP3sQ6g803" target="_blank" rel="noopener noreferrer">
              <Button className="bg-red-600 hover:bg-red-700 text-white font-semibold px-6 py-2.5 text-sm uppercase tracking-wider transition-all duration-300 hover:shadow-lg">
                Donate
              </Button>
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden text-[#0a1628] p-2 hover:bg-gray-100 rounded-lg transition-colors"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle menu"
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <nav className="lg:hidden pb-6 pt-2 border-t border-gray-100">
            <div className="space-y-1">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  onClick={() => setMobileMenuOpen(false)}
                  className={`block py-3 px-4 font-medium text-sm uppercase tracking-wide transition-colors rounded-lg ${
                    isActive(link.path) 
                      ? 'text-red-600 bg-red-50' 
                      : 'text-[#0a1628] hover:bg-gray-50'
                  }`}
                >
                  {link.label}
                </Link>
              ))}
            </div>
            <div className="mt-4 px-4">
              <a href="https://buy.stripe.com/4gMeVec2v4oP6XP3sQ6g803" target="_blank" rel="noopener noreferrer" onClick={() => setMobileMenuOpen(false)}>
                <Button className="w-full bg-red-600 hover:bg-red-700 text-white font-semibold py-3 text-sm uppercase tracking-wider">
                  Donate
                </Button>
              </a>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
